{{#if isTestEnvironment}}<a href="v2/">{{/if}}<img class="footer-logo" viewBox="0 0 825 176" src="img/sam_digital.svg" alt=""></img>{{#if isTestEnvironment}}</a>{{/if}}
